export default __webpack_public_path__ + "3f8615c387a65bf8c1ad78af45e03068.svg";